export const LoginFormInputData = [
  {
    id: 1,
    name: "email",
    placeholder: "example237484@site.com",
    type: "email",
    label: "Email",
    required: true,
  },
  {
    id: 2,
    name: "hashedPassword",
    placeholder: "Minimum 8 Characters",
    type: "password",
    label: "Password",
    required: true,
  },
];

export const inputData2 = [
  {
    id: 4,
    name: "name",
    type: "name",
    text: "Full Name",
    required: true,
  },
  {
    id: 1,
    name: "email",
    placeholder: "example@site.com",
    type: "email",
    text: "Email",
    required: true,
  },
  {
    id: 2,
    name: "hashedPassword",
    placeholder: "Minimum 8 Characters",
    type: "password",
    text: "hashedPassword",
    required: true,
  },
];

export const RegisterFormInputData = [
  {
    id: 4,
    name: "name",
    type: "name",
    text: "Your full Name",
    label: "Full Name",
    required: true,
  },
  {
    id: 1,
    name: "email",
    placeholder: "example@site.com",
    type: "email",
    text: "Email",
    label: "Email",
    required: true,
  },
  {
    id: 39,
    name: "hashedPassword",
    placeholder: "Please input your hashedPassword",
    type: "password",
    text: "Password",
    label: "Password",
    required: true,
  },
  {
    id: 34,
    name: "username",
    placeholder: "Please input your username",
    type: "text",
    text: "Username",
    label: "Username",
    required: true,
  },
];
export const DashboardProfileInputData = [
  {
    id: 4,
    name: "name",
    type: "name",
    text: "Full Name",
    label: "Full Name",
    required: false,
  },
  {
    id: 1,
    name: "email",
    placeholder: "example@site.com",
    type: "email",
    text: "Email",
    label: "Email",
    required: false,
  },

  {
    id: 34,
    name: "username",
    placeholder: "Please input your username",
    type: "text",
    text: "Username",
    label: "Username",
    required: false,
  },

  // {
  //   id: 36,
  //   name: "location",
  //   placeholder: "Please input your location",
  //   type: "text",
  //   text: "Location",
  //   label: "Location",
  //   required: false,
  // },
];

export const SellerFormInputData = [
  {
    id: 4,
    name: "name",
    type: "name",
    text: "Your full Name",
    label: "Full Name",
    required: true,
  },
  {
    id: 1,
    name: "email",
    placeholder: "example@site.com",
    type: "email",
    text: "Email",
    label: "Email",
    required: true,
  },
  {
    id: 39,
    name: "hashedPassword",
    placeholder: "Please input your hashedPassword",
    type: "password",
    text: "Password",
    label: "Password",
    required: true,
  },
  {
    id: 34,
    name: "username",
    placeholder: "Please input your username",
    type: "text",
    text: "Username",
    label: "Username",
    required: true,
  },
  {
    id: 39,
    name: "city",
    placeholder: "Please input your hashedPassword",
    type: "text",
    text: "City",
    label: "City",
    required: true,
  },
  {
    id: 34,
    name: "country",
    placeholder: "Please input your username",
    type: "text",
    text: "Country",
    label: "Country",
    required: true,
  },
];
export const ReviewInputData = [
  {
    id: 4,
    name: "description",
    type: "name",
    text: "Description",
    label: "Description",
    required: false,
    inputtype: "textarea",
  },

  {
    id: 34,
    name: "name",
    placeholder: "Please input your name",
    type: "text",
    text: "Name",
    label: "Name",
    required: false,
    inputtype: "input",
  },
  {
    id: 1,
    name: "email",
    placeholder: "example@site.com",
    type: "email",
    text: "Email",
    label: "Email",
    required: false,
    inputtype: "input",
  },
];
